<template>
  <div>
    <section-header size="sm">
      <heading
        level="4"
        size="sm"
        qaid="product-feedback-details__sub-header"
        v-html="bp('feedbackDetailsSubHeader')"
      />
    </section-header>
    <form-group
      v-model="feedbackData.claimLines[0].selectedFeedbackCategory"
      type="select"
      name="productCategory"
      :multi-items="categoryList"
      :label="bp('category')"
      class="max-w-xs"
    >
    </form-group>

    <form-group
      v-model="feedbackData.notes"
      v-validate="'max:2000'"
      class="max-w-lg"
      type="textArea"
      name="feedbackNote"
      qaid="product-feedback-details__notes"
      :help-text="`${bp('charactersRemaining')} ${noteCharactersRemaining}`"
      :label="bp('feedback')"
      :maxlength="maxNoteCharacters"
      :rows="15"
      :value="feedbackData.notes"
    />

    <div class="grid-x grid-margin-x mb-5">
      <div
        v-for="(n, index) in totalAttachments"
        :id="`attachment-${index}-${getAttachmentByIndex(index).name}`"
        :key="`${index}-${getAttachmentByIndex(index).name}`"
        class="cell large-4"
      >
        <label class="form-label" :qaid="`product-feedback__optional-attachments-image-${index}-label`"
          >{{ bp('supportingImg') }}
        </label>
        <file-upload
          :click-to-upload-msg="bp('uploadImage')"
          :help="null"
          :has-error="showAttachmentImageWarning && index === 0"
          :in-file-name="getAttachmentByIndex(index).name"
          :in-preset-image-file-url="getAttachmentByIndex(index).url"
          :input-id="`${claimIndex}_feedbackOptionalAttachments_${index}`"
          :qaid="`product-feedback-image-${index + 1}`"
          :upload-on-input="true"
          :upload-button="false"
          :base-properties="baseProperties"
          :file-too-large-msg="bp('fileTooLarge')"
          @file-uploaded="setImage({index: index}, $event)"
          @clear-file="clearImage(index)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex';
import FormGroup from '@/components/FormGroup';
import get from 'lodash/get';
import includes from 'lodash/includes';

export default {
  inject: ['$validator'],
  components: {FormGroup},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    feedbackData: {
      type: Object,
      default: () => {},
    },
    minAttachments: {
      type: Number,
      default: 3,
    },
    claimIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      maxNoteCharacters: 2000,
      validator: null,
      totalAttachments: 3,
    };
  },
  computed: {
    claimLine() {
      return this.feedbackData.claimLines[0];
    },
    showAttachmentImageWarning() {
      return this.feedbackData.claimLines[0] ? includes(this.feedbackData.claimLines[0].waitingCodeList, 'I') : false;
    },
    categoryList() {
      //this will be replaced with backend api call returning exact similar hash structure
      const categoryList = [];
      this.feedbackData.feedbackCategories.map((category) => {
        categoryList.push({value: category.code.toLowerCase(), displayName: category.name});
      });
      categoryList.push({value: null, displayName: this.bp('other')});
      return categoryList;
    },
    noteCharactersRemaining() {
      if (this.feedbackData.notes) {
        return this.maxNoteCharacters - this.feedbackData.notes.length;
      }
      return this.maxNoteCharacters;
    },
    ...mapState('productFeedback', ['validators']),
  },

  mounted() {
    const currentAttachmentsCount = !this.feedbackData.claimLines[0].warrantyOptionalAttachments
      ? 0
      : this.feedbackData.claimLines[0].warrantyOptionalAttachments.length;

    this.totalAttachments = Math.max(currentAttachmentsCount, this.minAttachments);
    this.validators.push(this.$validator);
  },

  methods: {
    getAttachmentByIndex(index) {
      return get(this.claimLine, `warrantyOptionalAttachments[${index}]`) || {};
    },

    setImage({index = null}, {name, encodedFile}) {
      this.$set(this.claimLine.warrantyOptionalAttachments, index || 0, {
        encodedFile,
        name,
        url: null,
      });
      this.saveImageInput().then(() => {
        this.reArrangeAttachmentCells();
      });
    },

    clearImage(index) {
      this.claimLine.warrantyOptionalAttachments[index] = {
        encodedImage: null,
        name: null,
        url: null,
      };

      this.$nextTick(() => {
        this.$validator.validateAll();
        this.reArrangeAttachmentCells();
      });
    },

    reArrangeAttachmentCells() {
      let result = [];
      for (let cell = 0; cell < this.totalAttachments; cell++) {
        const attachment = this.claimLine.warrantyOptionalAttachments[cell];
        if (!attachment || !Object.keys(attachment).length || !attachment.url) {
          continue;
        }
        result.push(attachment);
      }
      this.$set(this.feedbackData.claimLines[0], 'warrantyOptionalAttachments', result);
    },

    ...mapActions('productFeedback', ['saveImageInput', 'updateFlag']),
  },
};
</script>
